import controller from './attributes-presentation.controller';
import template from './attributes-presentation.html';
import './attributes-presentation.less';

const component = {
    template,
    bindings: {
        entity: '<',
        locale: '<',
    },
    controller: [controller],
};

export default component;
